<script setup lang="ts">
import { computedAsync } from '@vueuse/core';

import { TransportType } from '@libs/trip-planner-interfaces';
import { isExperimentAsync } from '@libs/feature-toggle';

import { ItinerarySegmentType } from '../../models';
import type { ItineraryNoTransportSegment } from '../../models';
import { useTripOverviewPageStore } from '../../stores';

import ItineraryTransportSelector from './ItineraryTransportSelector.vue';
import ItineraryIcon from './ItineraryIcon.vue';
import ItineraryTimeline from './ItineraryTimeline.vue';
import ExperimentalTransportSelector from './upsell/ExperimentalTransportSelector.vue';

interface ItineraryNoTransportSegmentProps {
  segment: ItineraryNoTransportSegment;
}

const props = defineProps<ItineraryNoTransportSegmentProps>();

const tripOverviewPageStore = useTripOverviewPageStore();

const isTransportBannerYellowExperiment = computedAsync(
  () => isExperimentAsync('transport_banner_yellow'),
  false
);

function selectTransport(transport: TransportType): void {
  tripOverviewPageStore.selectTransport(props.segment, transport);
}
</script>

<template>
  <ItineraryTimeline :segment-type="props.segment.segmentType">
    <template v-if="isTransportBannerYellowExperiment" #dropdown>
      <div class="exp-transport-banner">
        <ExperimentalTransportSelector
          @select-transport="selectTransport($event)"
        />
      </div>
    </template>
    <template
      v-else-if="tripOverviewPageStore.hasUserSelectedTransport"
      #dropdown
    >
      <ItineraryTransportSelector
        v-if="tripOverviewPageStore.hasUserSelectedTransport"
        :transport-type="TransportType.None"
        :disabled="false"
        :has-user-selected-transport="
          tripOverviewPageStore.hasUserSelectedTransport
        "
        :is-upsell-no-transport="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />
    </template>
    <template #icon>
      <ItineraryIcon
        v-if="!tripOverviewPageStore.hasUserSelectedTransport"
        :segment-type="ItinerarySegmentType.UpsellNoTransport"
      />
    </template>
    <template #header>
      <ItineraryTransportSelector
        v-if="
          !tripOverviewPageStore.hasUserSelectedTransport &&
          !isTransportBannerYellowExperiment
        "
        :transport-type="TransportType.None"
        :disabled="false"
        :has-user-selected-transport="
          tripOverviewPageStore.hasUserSelectedTransport
        "
        :is-upsell-no-transport="true"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />
    </template>
  </ItineraryTimeline>
</template>
